/* Measures the sticky header's ACTUAL rendered height and stores it
   as a CSS variable for the sticky collection filter sidebar to use.
   The theme's own built-in --header-height variable (set by Dawn's
   sticky-header script) can read stale/too-small values — e.g. if
   it measures before the logo image finishes loading — so this
   gives collection-sticky-filters.css a value it can trust. */
(function () {
  function syncHeaderHeightForFilters() {
    var header = document.querySelector('.header-wrapper');
    if (!header) return;
    var height = header.getBoundingClientRect().height;
    if (height > 0) {
      document.documentElement.style.setProperty('--sticky-filters-offset', (height + 20) + 'px');
    }
  }
  syncHeaderHeightForFilters();
  document.addEventListener('DOMContentLoaded', syncHeaderHeightForFilters);
  window.addEventListener('load', syncHeaderHeightForFilters);
  window.addEventListener('resize', syncHeaderHeightForFilters);
})();
